import * as z from "zod";

const output = z.union([
  z.object({ inActiveSplit: z.literal(false) }),
  z.object({
    inActiveSplit: z.literal(true),
    splitId: z.string(),
    splitName: z.string(),
    spotlightIds: z.array(z.string()),
  }),
]);
export type Output = z.infer<typeof output>;

export const getActiveRescuePanelSplitForTeam = {
  name: "getActiveRescuePanelSplitForTeam" as const,
  input: z.null(),
  output,
};
